export default "__VITE_ASSET__316eee0e__"